import { BackIcon } from '../Icons';

const SMSDemo = ({ shareText = "Here's your photo booth photo!", subdomain }) => {
  return (
    <div className="iphone-demo">
      <div className="iphone-demo__phone">
        <div className="iphone-demo__screen">
          <div style={{ top: 20 }} className="texts">
            <div className="texts__back">
              <BackIcon />
            </div>
            <div className="texts__list">
              <div className="texts__text">
                {shareText} <a href="#">{`https://${subdomain ? `${subdomain}.` : ''}boothpics.com/ABCD/abdef`}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMSDemo;
